import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-196dc4f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "spacer"
}
const _hoisted_6 = { class: "search-form" }
const _hoisted_7 = { class: "bar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_9 = { key: 2 }

import RoadmapInterface from '@/interfaces/RoadmapInterface'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import RoadmapService from '@/services/RoadmapService'
import CourseService from '@/services/CourseService'

import { onMounted, ref, Ref, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import RoadmapProgressbar from '@/components/widgets/RoadmapProgressbar.vue'
import FollowRoadmapWidget from '@/components/widgets/FollowRoadmapWidget.vue'
import useWindowWidth from '@/composables/useWindowWidth'


export default /*#__PURE__*/_defineComponent({
  __name: 'RoadmapView',
  setup(__props) {

const { windowWidth } = useWindowWidth()

const router = useRoute()
const roadmapService = new RoadmapService()
const courseService = new CourseService()
const loading = ref(true)

const courses:Ref<Array<RoadmapInterface>> = ref([])
const filteredCourses:Ref<Array<RoadmapInterface>> = ref([])

const roadmap: Ref<RoadmapInterface> = ref({
    id: 0,
    title: 'cargando...',
    description: 'cargando...',
    image_url: 'cargando...',
    created_at: 'cargando...',
    updated_at: 'cargando...'
})
const roadmap_id = ref(router.params.id)

const CourseCardLayout = defineAsyncComponent(() => import('@/layouts/CourseCardLayout.vue'))
const CourseTableLayout = defineAsyncComponent(() => import('@/layouts/CourseTableLayout.vue'))
const CourseListLayout = defineAsyncComponent(() => import('@/layouts/CourseListLayout.vue'))
const search: Ref<string> = ref('')
const layout = ref(CourseCardLayout)

const handleComponent = (cmp: any) => layout.value = cmp

onMounted(async () => {
    loading.value = true
    roadmap.value = await roadmapService.GetRoadmap(roadmap_id.value)
    courses.value = await courseService.GetCourseFromRoadmap(roadmap_id.value)
    filteredCourses.value = courses.value
    loading.value = false
})

const handleSearch = () => {
    loading.value = true
    filteredCourses.value = courses.value.filter((item:any)=> item.name.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", null, _toDisplayString(roadmap.value.title), 1),
              (_unref(windowWidth) > 950)
                ? (_openBlock(), _createBlock(FollowRoadmapWidget, {
                    key: 0,
                    roadmapId: roadmap.value.id,
                    class: "widget"
                  }, null, 8, ["roadmapId"]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_4,
            (_unref(windowWidth) <= 950)
              ? (_openBlock(), _createBlock(FollowRoadmapWidget, {
                  key: 0,
                  roadmapId: roadmap.value.id,
                  class: "widget",
                  style: {"margin-left":"0"}
                }, null, 8, ["roadmapId"]))
              : _createCommentVNode("", true),
            (_unref(windowWidth) <= 950)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("form", _hoisted_6, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                placeholder: "Filtrar cursos.",
                onKeyup: handleSearch
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(RoadmapProgressbar, {
                roadmapId: roadmap.value.id
              }, null, 8, ["roadmapId"])
            ]),
            _hoisted_8,
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_v_icon, {
                    name: "ri-loader-2-fill",
                    animation: "spin",
                    class: "icon"
                  })
                ]))
              : (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), {
                  key: 3,
                  content: filteredCourses.value,
                  showOrder: "true"
                }, null, 8, ["content"]))
          ]))
    ]),
    _: 1
  }))
}
}

})